import { StarFilled, StarOutlined } from '@ant-design/icons'
import { useLockFn } from 'ahooks'
import { Tooltip } from 'antd'
import axios from 'axios'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { ResourceType } from '@/schemas'

interface FavoriteProps {
  selfId: any
  isFavourited: boolean
  type: ResourceType
}

export const Favorite: React.FC<FavoriteProps> = ({ type, selfId, isFavourited }) => {
  const { t } = useTranslation()
  const [favorited, setFavorited] = React.useState(isFavourited)

  React.useEffect(() => {
    setFavorited(isFavourited)
  }, [selfId, isFavourited])

  React.useEffect(() => {
    if (isFavourited) {
      setFavorited(isFavourited)
    }
  }, [isFavourited])

  const onClick = useLockFn(async () => {
    await axios.request({
      url: favorited ? '/api/project/deleteProjectFavourite' : '/api/project/createProjectFavourite',
      method: 'POST',
      data: {
        selfId,
        type,
      },
    })
    setFavorited(!favorited)
  })

  if (favorited) {
    return (
      <Tooltip title={t('unfavourite')}>
        <StarFilled style={{ color: '#eab308' }} onClick={onClick} />
      </Tooltip>
    )
  } else {
    return (
      <Tooltip title={t('favourite')}>
        <StarOutlined onClick={onClick} />
      </Tooltip>
    )
  }
}
